import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var DebouncedAggregator = /*#__PURE__*/function () {
  function DebouncedAggregator(debounceIntervalMilliseconds, aggregatePolicy, handOver) {
    _classCallCheck(this, DebouncedAggregator);
    this.debounceIntervalMilliseconds = debounceIntervalMilliseconds;
    this.aggregatePolicy = aggregatePolicy;
    this.handOver = handOver;
    this.args = [];
    this.timeoutObject = void 0;
  }
  return _createClass(DebouncedAggregator, [{
    key: "aggregate",
    value: function aggregate(arg) {
      if (this.timeoutObject) {
        clearTimeout(this.timeoutObject);
        this.timeoutObject = undefined;
      }
      this.args.push(arg);
      this.timeoutObject = setTimeout(this.handOverAggregated.bind(this), this.debounceIntervalMilliseconds);
    }
  }, {
    key: "flushAggregatedData",
    value: function flushAggregatedData() {
      if (this.timeoutObject) {
        clearTimeout(this.timeoutObject);
        this.handOverAggregated();
      }
    }
  }, {
    key: "handOverAggregated",
    value: function handOverAggregated() {
      this.timeoutObject = undefined;
      if (this.args.length > 0) {
        var aggregatedData = this.aggregatePolicy.apply(this.args);
        this.handOver(aggregatedData);
        this.args = [];
      }
    }
  }]);
}();
